<app-group-header [Heading]="'Status' | translate"
                  [chart]="chart"
                  [info]="info"
                  [noChart]="true"
                  (chartEvent)="getChartEvent($event)"
                  (infoEvent)="getInfoEvent($event)">
</app-group-header>

<div class="card-group">

    <app-default-card class="card" style="border: none; border-radius: unset;"
                      [Heading]="'Betriebsart' | translate"
                      [showChart]="chart"
                      [showInfo]="info"
                      [customTemplate]="custom"
                      [customNoData]="OperatingMode == null"
                      [Legend]="['Betriebsart' | translate]"
                      [resizeEvent]="childResizeEvent"></app-default-card>

    <ng-template #custom>
        {{OperatingMode | operatingMode: operationModes}}
    </ng-template>
<!--
    <app-default-card *ngIf="Automatic?.TimeseriesData.currentDatapoint.value === 1" class="card" style="border: none; border-radius: unset;"
                      [Heading]="'Betriebsart' | translate"
                      [Error]="Automatic?.isError"
                      [ErrorLevel]="Automatic?.status"
                      [showChart]="chart"
                      [showInfo]="info"
                      [Values]="[Automatic?.TimeseriesData]"
                      [customTemplate]="AutomatikTemp"
                      [customNoData]="Automatic == null"
                      [Legend]="['Betriebsart' | translate]"
                      [resizeEvent]="childResizeEvent"></app-default-card>

    <ng-template #AutomatikTemp>
        {{'Automatik'}}
    </ng-template>

    <app-default-card *ngIf="AutmaticDisturbed?.TimeseriesData.currentDatapoint.value === 1" class="card" style="border: none; border-radius: unset;"
                      [Heading]="'Betriebsart' | translate"
                      [Error]="AutmaticDisturbed?.isError"
                      [ErrorLevel]="AutmaticDisturbed?.status"
                      [showChart]="chart"
                      [showInfo]="info"
                      [Values]="[AutmaticDisturbed?.TimeseriesData]"
                      [customTemplate]="AutmaticDisturbedTemp"
                      [customNoData]="AutmaticDisturbed == null"
                      [Legend]="['Betriebsart' | translate]"
                      [resizeEvent]="childResizeEvent"></app-default-card>

    <ng-template #AutmaticDisturbedTemp>
        {{'Automatik gestört'}}
    </ng-template>

    <app-default-card *ngIf="CollectivFault?.TimeseriesData.currentDatapoint.value === 1" class="card" style="border: none; border-radius: unset;"
                      [Heading]="'Betriebsart' | translate"
                      [Error]="CollectivFault?.isError"
                      [ErrorLevel]="CollectivFault?.status"
                      [showChart]="chart"
                      [showInfo]="info"
                      [Values]="[CollectivFault?.TimeseriesData]"
                      [customTemplate]="CollectivFaultTemp"
                      [customNoData]="CollectivFault == null"
                      [Legend]="['Betriebsart' | translate]"
                      [resizeEvent]="childResizeEvent"></app-default-card>

    <ng-template #CollectivFaultTemp>
        {{'Sammelfehler'}}
    </ng-template>

    <app-default-card *ngIf="Manual?.TimeseriesData.currentDatapoint.value === 1" class="card" style="border: none; border-radius: unset;"
                      [Heading]="'Betriebsart' | translate"
                      [Error]="Manual?.isError"
                      [ErrorLevel]="Manual?.status"
                      [showChart]="chart"
                      [showInfo]="info"
                      [Values]="[Manual?.TimeseriesData]"
                      [customTemplate]="ManualTemp"
                      [customNoData]="Manual == null"
                      [Legend]="['Betriebsart' | translate]"
                      [resizeEvent]="childResizeEvent"></app-default-card>

    <ng-template #ManualTemp>
        {{'Hand'}}
    </ng-template>
-->
    <!--
    <div class="card rounded-0"
         style="height: calc(100% - 50px)"
         [class.border-danger]="FirstErrorNumberError && FirstErrorNumberErrorLevel === monitoringLevel.Error"
         [class.border-warning]="FirstErrorNumberError && FirstErrorNumberErrorLevel === monitoringLevel.Warning"
         [class.border-info]="FirstErrorNumberError && FirstErrorNumberErrorLevel === monitoringLevel.Info">

        <div class="card-header" style="padding:5px;">
            Erste Fehlernummer
        </div>
        <div class="card-body" [style.fontSize]="fontsizeFull" style="height: 100%; padding:5px; display: flex; justify-content: center; align-items: center">
            {{FirstErrorNumberValue}}
        </div>
    </div>
    -->

    <app-default-card class="card" style="border: none; border-radius: unset;"
                      [Heading]="'Betriebsstunden' | translate"
                      [Error]="OperatingHours?.isError"
                      [ErrorLevel]="OperatingHours?.status"
                      [showChart]="chart"
                      [showInfo]="info"
                      [Values]="[OperatingHours?.TimeseriesData]"
                      [Unit]="'h'"
                      [MaintenanceValue]="OperatingHours?.ValueLastService"
                      [Legend]="['Auslagerung' | translate, 'Stand Wartung' | translate]"
                      [resizeEvent]="childResizeEvent"></app-default-card>

</div>
